import { SingularStationArea } from '@thive/fddm-types';
import { Vector3 } from 'three';

import { logger } from '@/modules/common/logging/logger';

import { IFlowService } from './IFlowService';
import { FlowStopType } from '../store/useActiveFlowStore';

export class FlowServiceLogDecorator implements IFlowService {
  private decoree: IFlowService;

  constructor(decoree: IFlowService) {
    this.decoree = decoree;
  }

  startFlow(
    pointA: Vector3,
    id: string,
    flowStopType: FlowStopType,
    loadHandlingType: SingularStationArea['loadHandlingType'],
    toolState: 'transport_flow' | 'consolidation_flow' | 'external_flow',
  ): void {
    const start = this.logStart('startFlow');
    this.decoree.startFlow(pointA, id, flowStopType, loadHandlingType, toolState);
    this.logEnd('startFlow', start);
  }

  endFlow(sourceId: string, destinationId: string): void {
    const start = this.logStart('endFlow');
    this.decoree.endFlow(sourceId, destinationId);
    this.logEnd('endFlow', start);
  }

  activateTool(type: 'transport_flow' | 'consolidation_flow' | 'external_flow'): void {
    const start = this.logStart('activateTool [in flow service]');
    this.decoree.activateTool(type);
    this.logEnd('activateTool [in flow service]', start);
  }

  cancelTool(): void {
    const start = this.logStart('cancelTool');
    this.decoree.cancelTool();
    this.logEnd('cancelTool', start);
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
